import {
  isSecondaryMarketQuotesCpOrderPersistedTabContent,
  isSecondaryPostEventsCpOrderPersistedTabContent,
} from 'apiConnector/tabs/secondaryMarket.tabs.model';
import type { Action } from 'state/actions';
import type { TradeSizeInputMode } from 'state/secondaryMarket/shared/tradeInformation.models';
import { addKey, addOrReplaceKey, patchKey, removeKey } from 'state/utils/collection';

import type { SecondaryMarketCpOrderFormMap } from './cpOrderInputForm.model';
import { initialCpOrderForm, initialCpOrderFormMap } from './cpOrderInputForm.model';

export function inputFormReducer(
  state: SecondaryMarketCpOrderFormMap = initialCpOrderFormMap,
  action: Action,
): SecondaryMarketCpOrderFormMap {
  switch (action.type) {
    case 'WORKSPACE_TAB_CREATED':
      if (action.workspace === 'secondaryMarketQuotes' && action.tabType === 'closePriceOrder') {
        return addKey(state, action.id, initialCpOrderForm);
      }
      return state;
    case 'SECONDARY_MARKET_POSTEVENT_WORKSPACE_ADD_TAB':
      return addKey(state, action.tabId, initialCpOrderForm);
    case 'SECONDARY_MARKET_CP_ORDER_FORM_TAB_FETCHED':
      return addKey(state, action.tabId, initialCpOrderForm);
    case 'SECONDARY_MARKET_AMEND_CP_ORDER_FETCHED':
      return patchKey(state, action.tabId, () => ({
        tradeSizeInputMode: (action.data.tradeSizeInputMode as TradeSizeInputMode) ?? 'quantity',
      }));
    case 'WORKSPACE_TAB_CONTENT_FETCHED':
      if (
        isSecondaryMarketQuotesCpOrderPersistedTabContent(action.tabContent) ||
        isSecondaryPostEventsCpOrderPersistedTabContent(action.tabContent)
      ) {
        const {
          workspace: _workspace,
          bcsProductKey: _bcsProductKey,
          tabType: _tabType,
          tradeSizeInputMode,
          ...formData
        } = action.tabContent;
        return addOrReplaceKey(state, action.tabId, {
          tradeSizeInputMode: tradeSizeInputMode ?? 'quantity',
          ...formData,
        });
      }
      return state;
    case 'SECONDARY_MARKET_DOMINO_SETTLEMENT_DATE_RECEIVED':
      return patchKey(state, action.tabId, () => ({
        settlementDate: action.settlementDate,
        firstSettlementDate: action.firstSettlementDate,
      }));
    case 'SECONDARY_MARKET_CP_ORDER_FORM_FIELD_CHANGED':
      return patchKey(state, action.tabId, () => ({ [action.field]: action.value }));
    case 'SECONDARY_MARKET_CP_ORDER_FORM_RESET':
      return addOrReplaceKey(state, action.tabId, initialCpOrderForm);
    case 'SECONDARY_MARKET_POSTEVENT_WORKSPACE_REMOVE_TAB':
    case 'SECONDARY_MARKET_QUOTES_WORKSPACE_REMOVE_TAB':
      if (action.tabType === 'closePriceOrder') {
        return removeKey(state, action.tabId);
      }
      return state;

    default:
      return state;
  }
}
